export const selectDraft = (state, key) =>
  state.uiDrafts?.drafts?.[key]?.data || null;
